import "./sdk";

export default function wakeToAlipay(url) {
    
    if (!window.wakeup) return;
    
    window.wakeup("platformapi/startapp", {
        scheme: "alipays:",
        params: {
            appId: '2018032302435038',
            page: "pages/home/home",
            query:`url=${url}`
        }
    });
}


// WEBPACK FOOTER //
// ./src/wakeup/index.js